import { render, staticRenderFns } from "./VoiceSoftphoneDock.vue?vue&type=template&id=9264e274&scoped=true"
import script from "./VoiceSoftphoneDock.vue?vue&type=script&lang=js"
export * from "./VoiceSoftphoneDock.vue?vue&type=script&lang=js"
import style0 from "./VoiceSoftphoneDock.vue?vue&type=style&index=0&id=9264e274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9264e274",
  null
  
)

export default component.exports